import React, { useEffect, useState } from "react";
import { Empty, Button, Modal, Form, Input, message,Typography, Divider } from "antd";
import { useOutletContext } from "react-router-dom";
import useClientStore from "../../../store/clientModal.store";
import useMembersStore from "../../../store/members.store";
import CustomerTableSelectable from "../../customerTableSelectable";

import Rtable from "../../RTable";
import "./barredCompany.scss";
const taListTitle = [
    "Select",
    "S. No.",
    "Company Name",
    "Location",
];



function BarredCompanyList() {
    const { clientName, clientID } = useOutletContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { handleAddBarredCompany, setCurrentClientName, removeClientTA } = useClientStore();
    const [barredCompanyList, setBarredCompanyList] = useState([]);
const { Title, Text } = Typography;
    const { clients, getClients } = useMembersStore();
    useEffect(() => {
        getClients();
    }, [getClients]);
    useEffect(() => {
        if (!clients?.[clientID]) return;

        const client = clients[clientID];

        if (client.ClientName !== clientName) return;
        console.log("client inside func", client);


        const mappedList =
            client.ClientBarredComanies?.map((company, idx) => ({
                select: "",
                id: idx + 1,
                name: company?.CompanyName,
                location: company?.CompanyLocation,

            })) || [];
        console.log("mappedlist", mappedList);


        setBarredCompanyList(mappedList);

    }, [clients]);
    console.log("barredCompanyList", barredCompanyList);


    console.log("clients barred", clients);


    const handleAddClick = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const handleSubmit = async (values) => {
        setLoading(true);
        console.log("clientName", clientName);
        setCurrentClientName({ clientName: clientName });
        console.log("values", values);

        await handleAddBarredCompany(values);
        setLoading(false);
        setIsModalOpen(false);
        form.resetFields();
    };

    return (
        <div className="customers-container">
            <div className="customer-members-wrapper">

                {/* Company Title */}
                <div style={{ textAlign: "center", marginBottom: 16 }}>
                    <Title level={3} style={{ marginBottom: 0 }}>
                        {clients?.[clientID]?.ClientName.toUpperCase()}
                    </Title>
                    
                </div>


                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 16,
                    }}
                >
                   <h2 className="customer-members-list-title">List of TAs</h2>

                    <Button type="primary" onClick={handleAddClick}>
                        + Add Barred Company
                    </Button>
                </div>

            
                {barredCompanyList.length > 0 ? (
                    <Rtable
                        titleList={taListTitle}
                        data={barredCompanyList}
                        removeClientTA={removeClientTA}
                        clientName={clientName}
                    />
                ) : (
                    <Empty style={{ margin: 60 }} />
                )}
            </div>


            <Modal
                title="Add Barred Company"
                open={isModalOpen}
                onCancel={handleCancel}
                onOk={() => form.submit()}
                confirmLoading={loading}
                className="subUserAddModel-title"
            >
                <Form
                    form={form}
                    labelCol={{ flex: "150px" }}
                    labelAlign="left"
                    wrapperCol={{ flex: 1 }}
                    colon={false}
                    onFinish={handleSubmit}
                >
                    <Form.Item
                        label="Company Name"
                        name="companyname"
                        rules={[{ required: true, message: "Company name is required" }]}
                    >
                        <Input
                            size="middle"
                            placeholder="Enter company name"
                            style={{ textAlign: "left" }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Location"
                        name="companylocation"
                    >
                        <Input
                            size="middle"
                            placeholder="Enter location (optional)"
                            style={{ textAlign: "left" }}
                        />
                    </Form.Item>

                    <Form.Item>
                        {/* <Button htmlType="submit" type="primary" loading={loading}>
                            Submit
                        </Button> */}
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default BarredCompanyList;